import { WIZ_EVENT_TYPE, VALUE_ENTER, VALUE_ESCAPE, WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import {
  WizBasePopUp,
  WizButton,
  WizComponentManager,
  WizDatasource,
  WizIcon,
  WizLabel,
  WizPopUp,
  WizTextarea,
  PopUpManager,
  WizEventManager, WizEvent, WizTranslationManager
} from '@wizeoo/akm-component-lib';
import { FunctionObj, FunctionCoreEngine, WizConstants, FeiKeyDef, BaselineEngine, MeasureVO, KEY_KIND, MeasMode, MeasModeItem, MeasureCoreEngine } from '@wizeoo/akm-compute-lib';
import { AfterViewInit, Component, ComponentRef, ElementRef, HostListener, ViewChild, ViewContainerRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AddMeasurePop } from './add-measure.pop';
import { AddFunctionPop } from './add-function.pop';
import { FormulaEditorInput } from './compos/formula-editor.input';
import { Model } from '../../../model/model';
import { FeiVO } from '../../../vo/workingdata/fei.vo';
import { MeasureParams } from '../../../manager/workingdata/measure.engine';

export interface FormulaEditorParams {
  fei: FeiVO;
  measure: MeasureVO;
  mode: string;
  callback: Function;
}

@Component({
  // popup de construction des formules
  selector: 'formula-editor-pop',
  templateUrl: './formula-editor.pop.html',
  styleUrls: ['./formula-editor.pop.scss'],
})
export class FormulaEditorPop extends WizBasePopUp implements AfterViewInit {
  
  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
 
    if(!!this.subPop) {
      // console.log('hostInFormulaEditorPop trapped', event);;
    } else {
      if (event.key === VALUE_ENTER) {
        event.stopImmediatePropagation();
        event.preventDefault();
        this.save();
      }
      if (event.key === VALUE_ESCAPE) {
        event.stopImmediatePropagation();
        event.preventDefault();
        this.hide();
      }
    }
  }

  // détection de sous-pop pour ne pas agir sur ENTER / ESC
  public subPop: WizPopUp = null;
  
  @ViewChild('lblTitle', { read: WizLabel }) lblTitle: WizLabel; // titre de la fenêtre
  @ViewChild('editDiv') editDiv: ElementRef; // la div de présentation de la formule
  @ViewChild('errorDiv') errorDiv: ElementRef; // la div d'affichage des erreurs
  @ViewChild('descDiv') descDiv: ElementRef; // la div de détail des formules / fonctions
  @ViewChild('mainEdit', { read: WizTextarea }) mainEdit: WizTextarea;
  // zone d'ajout des champs de saisie
  @ViewChild('containerInputs', { read: ViewContainerRef, static: true }) containerInputs: ViewContainerRef;

  @ViewChild('lblSubTitle', { read: WizLabel }) lblSubTitle: WizLabel; // titre de la zone d'édition
  @ViewChild('subClose', { read: WizIcon }) subClose: WizIcon; // icone de fermeture de la zone d'édition
  @ViewChild('btnSave', { read: WizButton }) btnSave: WizButton; // bouton d'enregistrement

  public model: Model; 
  public mode: string; // le mode choisi (FIST)
  public source: MeasureVO = null; // la mesure d'origine
  public clone: MeasureVO = null; // instance de travail
  protected updateCallback: Function; // la callback pour retour et traitement

  protected doSaveFlag: boolean = false; // marqueur de validation des modifs (false sur cancel)

  public measureDS: WizDatasource<FeiKeyDef>; // la collection de mesures disponibles
  public functionDS: WizDatasource<FunctionObj>; // la collection de fonctions disponibles

  public currentFormula: string; // la formule en cours de saisie
  public currentFormulaParts: string[];
  public currentCaretStart: number; // début de sélection
  public currentCaretEnd: number; // fin de sélection

  public currentFormulaKindParts: string[]; // les types d'objets pour chaques éléments (pour identifier facilement les mesures et les fonctions)
  public currrentFormulaHtmlParts: string[]; // la formule splitée en éléments autonomes, rendu HTML
  public currentFormulaHtml: SafeHtml = ''; // <span class="blinking">|</span>+12'; // la formule en cours de saisie
  public currentErrorHtml: SafeHtml = ''; // l'erreur en cours sur la formule

  public currentDescHtml: SafeHtml = ''; // le contenu de la div de description
  public caretStart: any = '<span class="blinking">[..</span>';
  public caretEnd: any = '<span class="blinking">..]</span>';
  public caret: any = '<span class="blinking">|</span>'; // le caret virtuel

  public keyMap: Map<string, FeiKeyDef>; // Map de mesures (pivotKeys)

  public currentEditedFunction: FunctionObj; // fonction en cours d'édition, passage en mode complexe, sinon mode simple
  /** les champs de saisie */
  public inputComponents: ComponentRef<FormulaEditorInput>[];

  /** le dernier composant de saisie à avoir eu le focus */
  public lastFocusComponent: WizTextarea;

  constructor(public elementRef: ElementRef, private sanitizer: DomSanitizer) {
    super();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      let params: MeasureParams = this.datas;
      this.model = params.model;
      this.source = params.measure;
      this.mode = params.mode;
      this.clone = this.model.measureEngine.clone(this.source);
      
      this.updateCallback = params.callback;

      this.feed();
      this.addListeners();
    }, 0);
  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    WizEventManager.addListener(this, this.mainEdit, WIZ_EVENT_TYPE.CHANGE, this.updateFunctionRenderer);
  }

  /** détection de la position du caret pour réplique sur la formule complète en span */
  public checkCaret(): void {
    const field: string = '_wizInput';
    this.currentCaretStart = this.mainEdit[field].nativeElement.selectionStart;
    this.currentCaretEnd = this.mainEdit[field].nativeElement.selectionEnd;
    // console.log('caret', this.currentCaretStart, this.currentCaretEnd);

    this.lastFocusComponent = this.mainEdit; // définir le focus

    this.spanMe();
  }

  /**
   * changement dans les zones d'édition, répercussion sur la zone de formule
   * @param e change sur une zone
   */
  private updateFunctionRenderer(e: WizEvent): void {
    this.currentFormula = this.mainEdit.wizValue;
    this.checkCaret(); // va positionner les curseurs
  }

  /** alimentation des composants */
  private feed(): void {
    // this.lblTitle.wizLabel = this.clone.code + FormulaCoreEngine.MODE_SEPARATOR + this.mode;
    this.lblTitle.wizLabel = this.clone.shortCode + WizConstants.CONTEXT_SEPARATOR + this.mode;
    this.currentFormula = this.clone['formula' + this.mode];
    if (!this.currentFormula || this.currentFormula === undefined) {
      this.currentFormula = '';
    }
    this.currentCaretStart = this.currentCaretEnd = this.currentFormula.length;

    // collecte de toutes les mesures et des WeightGrids
    const keys: FeiKeyDef[] = [];
    // TODO sur style.condition, prendre le stepLevel du FEI
    const allMeasures: MeasureVO[] = this.model.measureEngine.getMeasureAndWg(
      this.model.visionCode,
      this.model.currentStepLevel
    ); // TODO tenir compte du step
    // TODO ne prendre que les modes autorisés
    let keyDef: FeiKeyDef;
    allMeasures.forEach((m: MeasureVO) => {
      if (!!m.mode) {
        m.mode.split('').forEach((mode: string) => {
          keyDef = BaselineEngine.buildFeiKeyDef(this.model.measureEngine.currentFEI, KEY_KIND.MEASURE, m.source, mode).setParams(false, true, null).setSize(150);
          keys.push(keyDef);
        });
      }
    });

    this.keyMap = new Map(keys.map((fkd: FeiKeyDef) => [fkd.fullCode, fkd]));

    this.spanMe(); // génération de la formule en mode rendu HTML
    // construction des zones de saisie
    this.buildInputs();
  }

  /** validation du contenu */
  public save(): void {
    this.doSaveFlag = true;
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.hide();
  }

  public onHide() {
    if (this.doSaveFlag) {
      this.updateCallback(this);
    }
  }

  /**
   * Ajout d'un élément de fonction depuis les composants
   * @param part le string à ajouter à la formule
   * @param htmlPart le rendu pour ajout
   */
  private addPart(parts: string[]): void {
    const field: string = '_wizInput';
    const ta: HTMLTextAreaElement = this.lastFocusComponent[field].nativeElement;
    const startPos: number = ta.selectionStart;
    const endPos: number = ta.selectionEnd;
    const value: string = ta.value;

    const startStr: string = value.substring(0, startPos);
    const endStr: string = value.substring(endPos, value.length);
    this.lastFocusComponent.wizValue = startStr + parts.join('') + endStr;
    // ta.value = startStr + parts.join('') + endStr;
    WizEventManager.dispatchEvent(this.lastFocusComponent, new WizEvent(WIZ_EVENT_TYPE.CHANGE));
    setTimeout(() => {
      this.lastFocusComponent.wizFocus();
      let newCaretPos: number = startStr.length + parts.join('').length;
      if (parts.length > 1) {
        newCaretPos--; // on recule de 1 en cas d'ajout de fonction (pour être dans les parenthèses)
      }
      ta.selectionStart = ta.selectionEnd = newCaretPos;
    }, 0);
  }

  /**
   * clic sur un bouton d'opérateur
   * @param value: string
   * @param value2: la 2ème parenthèse
   */
  public addOperator(value: string, value2?: string): void {
    const toAdd: string[] = [value];
    if (value2) {
      toAdd.push(value2);
    }
    this.addPart(toAdd);
  }

  /** alimentation de la zone de formule complète */
  private spanMe(): void {
    this.clone['formula' + this.mode] = this.currentFormula;
    const mm: MeasMode = MeasureCoreEngine.measureModeFromFormula(this.model.measureEngine.currentFEI, this.clone.source, this.mode);
    let parts: string[] = []; // les éléments de la formule
    let htmlParts: string[] = []; // les rendus HTML de ces éléments
    let kindParts: string[] = []; // les types d'objets
    if (mm.form?.length > 0 && mm.form.trim()[0] === '=') {
      // ajout du = initial
      parts.push('=');
      htmlParts.push('<span id="' + htmlParts.length + '">' + '=' + '</span>');
      kindParts.push('=');
    }
    if (mm) {
      this.spanMeRecurse(mm.mmi, parts, htmlParts, kindParts);
    }

    if (parts.join('') !== this.currentFormula) {
      // erreur, il manque un morceau... on prends toute l'erreur
      // console.log(FunctionCoreEngine.EXTRA_SPACE_ERROR, mm.formula, parts.join(''));
      if (!mm.isErr) {
        // c'est juste les espaces, pas très grave
        mm.isErr = true;
        mm.errC = FunctionCoreEngine.EXTRA_SPACE_ERROR;
      }
      parts = [this.currentFormula];
      htmlParts = ['<span id="0">' + this.currentFormula + '</span>'];
      kindParts = ['basic'];
    }

    // gestion des erreurs : affichage dans la div
    if (mm.isErr) {
      this.currentErrorHtml = this.sanitizer.bypassSecurityTrustHtml(
        WizTranslationManager.getInstance().translateKey('$.formula.error.' + mm.errC + '.$') +
          ': ' +
          mm.errS
      );
    } else {
      this.currentErrorHtml = '';
    }

    this.currentFormulaParts = parts;
    this.currrentFormulaHtmlParts = htmlParts;
    this.currentFormulaKindParts = kindParts;

    let firstSpan: any = null;
    let secondSpan: any = null;

    if (this.currentCaretStart === this.currentCaretEnd) {
      // caret simple
      firstSpan = this.caret;
    } else {
      // zone
      firstSpan = this.caretStart;
      secondSpan = this.caretEnd;
    }

    let caretIdx: number = -1; // on va chercher le bon segment
    let previousStringSize: number = 0; // on va mesurer la taille des segments antérieurs cumulés
    let currentStringSize: number = 0; // taille cumulée de contrôle

    this.currentFormulaParts.forEach((part: string) => {
      // on balaie la formule pour trouver la bonne zone
      currentStringSize += part.length;
      caretIdx++;
      if (firstSpan && currentStringSize >= this.currentCaretStart) {
        // on va position le 1er span
        const realOffset: number = this.currentCaretStart - previousStringSize;
        const htmlPart = this.currrentFormulaHtmlParts[caretIdx]; // on prend le texte "vrai" du span focus
        const backOffset: number = 7 + (this.currentFormulaParts[caretIdx].length - realOffset); // on se base sur la fin de chaine -7 (</span>) - le delta entre taille réelle et offset

        const htmlPartArr: string[] = Array.from(this.currrentFormulaHtmlParts[caretIdx]).reverse(); // on fait un array du htmlPart pour injection par splice
        htmlPartArr.splice(backOffset, 0, firstSpan);
        this.currrentFormulaHtmlParts[caretIdx] = htmlPartArr.reverse().join('');

        // console.log('start', this.currrentFormulaHtmlParts[caretIdx]);

        firstSpan = null; // et on ne passe plus ici
      }
      if (secondSpan && currentStringSize >= this.currentCaretEnd) {
        // on va position le 2ème span
        const realOffset: number = this.currentCaretEnd - previousStringSize;
        const htmlPart = this.currrentFormulaHtmlParts[caretIdx]; // on prend le texte "vrai" du span focus
        const backOffset: number = 7 + (this.currentFormulaParts[caretIdx].length - realOffset); // on se base sur la fin de chaine -7 (</span>) - le delta entre taille réelle et offset

        const htmlPartArr: string[] = Array.from(this.currrentFormulaHtmlParts[caretIdx]).reverse(); // on fait un array du htmlPart pour injection par splice
        htmlPartArr.splice(backOffset, 0, secondSpan);
        this.currrentFormulaHtmlParts[caretIdx] = htmlPartArr.reverse().join('');

        // console.log('start', this.currrentFormulaHtmlParts[caretIdx]);
        secondSpan = null; // et on ne passe plus ici
      }

      previousStringSize += part.length;
    });

    // console.log('span', this.currrentFormulaHtmlParts);
    this.currentFormulaHtml = this.sanitizer.bypassSecurityTrustHtml(this.currrentFormulaHtmlParts.join('')); // this.clone['formula' + this.mode]);

    // et gestion de l'erreur pour activer ou pas le bouton applyChanges
    if (mm.isErr) {
      this.btnSave.wizDisabled = true;
    } else {
      this.btnSave.wizDisabled = false;
    }
  }

  /**
   * alimentation récursive des <span> sur la base des mmi de la formule en cours
   * @param mmi le mmi à convertir
   * @param parts le tableau global des chaines html
   * @param htmlParts: les chaines html
   * @param kindParts: les types d'objets
   */
  private spanMeRecurse(mmi: MeasModeItem, parts: string[], htmlParts: string[], kindParts: string[]): void {
    if (mmi.fSis) {
      parts.push('(');
      htmlParts.push('<span id="' + htmlParts.length + '">' + '(' + '</span>');
      kindParts.push('parenthesis');
    } else if (mmi.fFunc && !mmi.isErr) {
      parts.push(mmi.funcCode);
      parts.push('(');
      htmlParts.push('<span id="' + htmlParts.length + '" class="edit-tool-function">' + mmi.funcCode + '</span>');
      htmlParts.push(
        '<span id="' + htmlParts.length + '" class="edit-tool-function-parenthesis-open">' + '(' + '</span>'
      );
      kindParts.push('function');
      kindParts.push('parenthesis');
    }

    if (mmi.fTer || (mmi.fFunc && mmi.isErr)) {
      // écriture des terminaux
      parts.push(mmi.form);

      if (mmi.fRand) {
        // pour les measures / constantes, rendu
        htmlParts.push('<span id="' + htmlParts.length + '" class="edit-tool-operand">' + mmi.form + '</span>');
        kindParts.push('operand');
      } else if (mmi.fOper) {
        // pour les +-*/
        htmlParts.push('<span id="' + htmlParts.length + '" class="edit-tool-operator">' + mmi.form + '</span>');
        kindParts.push('operator');
      } else if (mmi.fComp) {
        // pour les <=>
        htmlParts.push(
          '<span id="' + htmlParts.length + '" class="edit-tool-comparator">' + mmi.form + '</span>'
        );
        kindParts.push('comparator');
      } else if (mmi.ftxt) {
        // pour les ""
        htmlParts.push('<span id="' + htmlParts.length + '" class="edit-tool-text">' + mmi.form + '</span>');
        kindParts.push('text');
      } else {
        htmlParts.push('<span id="' + htmlParts.length + '">' + mmi.form + '</span>');
        kindParts.push('basic');
      }
    } else {
      let nbParams: number = mmi.c.length;
      mmi.c.forEach((mmic: MeasModeItem) => {
        this.spanMeRecurse(mmic, parts, htmlParts, kindParts);
        nbParams--;
        if (mmi.fFunc && nbParams > 0) {
          parts.push(';');
          htmlParts.push('<span id="' + htmlParts.length + '" class="edit-tool-function">;</span>');
          kindParts.push('separator');
        }
      });
    }

    if (mmi.fSis) {
      parts.push(')');
      htmlParts.push('<span id="' + htmlParts.length + '">' + ')' + '</span>');
      kindParts.push('parenthesis');
    } else if (mmi.fFunc && !mmi.isErr) {
      parts.push(')');
      htmlParts.push(
        '<span id="' + htmlParts.length + '" class="edit-tool-function-parenthesis-close">' + ')' + '</span>'
      );
      kindParts.push('parenthesis');
    }
  }

  /** double click sur la div de formule pour switch d'éléments */
  public showEditorFromDiv(e: MouseEvent): void {
    // console.log('sfd', e, e.target['id']);
    const field: string = 'id';
    const idx: number = Number(e.target[field]);
    const previousStr: string = this.currentFormulaParts.slice(0, idx).join('');
    this.currentCaretStart = previousStr.length;
    this.currentCaretEnd = this.currentCaretStart + this.currentFormulaParts[idx].length;
    this.showEditor();
  }

  /** double click dans le textArea. Affichage du détail en cas de mesure, affichage de l'éditeur en cas de fonction */
  public showEditor(): void {
    // on essaie d'identifier une fonction ou une mesure
    let valuableObject: string = null; // l'objet
    let kind: string; // son type
    let idx: number = -1; // son index

    let caretIdx: number = -1; // on va chercher le bon segment
    let currentStringSize: number = 0; // taille cumulée de contrôle
    this.currentFormulaParts.forEach((part: string) => {
      // on balaie la formule pour trouver la bonne zone
      currentStringSize += part.length;
      caretIdx++;
      if (!valuableObject && currentStringSize > this.currentCaretStart) {
        // directement supérieur
        // correction du currentStart. Sur #I, il sélectionne après le #
        this.currentCaretStart = this.currentFormulaParts.slice(0, caretIdx).join('').length;
        const field: string = '_wizInput';
        this.mainEdit[field].nativeElement.selectionStart = this.currentCaretStart;
        valuableObject = part;
        kind = this.currentFormulaKindParts[caretIdx];
        idx = caretIdx;
      }
    });

    // console.log('itsme', valuableObject, idx, this.currentFormulaKindParts[idx]);
    this.currentEditedFunction = null;

    if (valuableObject) {
      const htmlParts: string[] = []; // les lignes pour la construction de la description
      if (kind === 'operand') {
        // mesure ou constante

        const fkd: FeiKeyDef = this.keyMap.get(valuableObject);
        htmlParts.push('<span class="componentLabel">' + fkd.fullCode + '</span></br></br>');
        htmlParts.push('<span>' + fkd.measure['formula' + fkd.mode] + '</span>');
        this.currentDescHtml = this.sanitizer.bypassSecurityTrustHtml(htmlParts.join(''));

        // altération de la sélection pour prendre en compte le #I
        this.currentCaretEnd = this.currentCaretStart + fkd.fullCode.length;
        // this.mainEdit['_wizInput'].nativeElement.selectionEnd = this.currentCaretEnd;
      } else if (kind === 'function') {
        // fonction
        // console.log('showFunc', e.currentTarget, e.target);

        const fo: FunctionObj = FunctionCoreEngine.functionMap(this.model).get(valuableObject); // isolation de la fonction
        fo.feedDatas(this.model.measureEngine.currentFEI, this.clone, this.mode, idx); // construction des données nécessaire sur le fo
        this.currentEditedFunction = fo;

        // altération de la sélection pour prendre en compte le #I
        this.currentCaretEnd = this.currentCaretStart + fo.mmi.form.length;

        htmlParts.push('<span class="componentLabel">' + fo.code + ' : </span>');
        htmlParts.push('<span>' + fo.getDescription() + '</span></br>');

        this.currentDescHtml = this.sanitizer.bypassSecurityTrustHtml(htmlParts.join(''));
      } else {
        this.currentDescHtml = this.sanitizer.bypassSecurityTrustHtml('');
      }
    } else {
      this.currentDescHtml = this.sanitizer.bypassSecurityTrustHtml('');
    }

    this.spanMe(); // on redessine la sélection dans la div
    this.buildInputs(); // reconstruction des éléments d'affichage
  }

  /** ouverture de la popUp d'ajout de fonction */
  public showFormulaPop(): void {
    let params: MeasureParams = {
      measure: this.clone,
      mode: this.mode,
      model: this.model,
      callback: this.backFromAddFunctionPop.bind(this)
    }


    this.subPop = new WizPopUp(
      AddFunctionPop,
      true,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      '680px',
      '360px',
      params
    ).show();
  }

  /**
   * retour de popUp d'ajout de fonction
   * @param fo: FunctionObj
   */
  private backFromAddFunctionPop(fo: FunctionObj): void {
    PopUpManager.doHide(this.subPop, true);
    this.subPop = null;
    if (fo) {
      this.addPart([fo.code, '(', ')']);
    }
   }

  /**
   * ouverture de la popUp d'ajout de mesure
   */
  public showMeasurePop(): void {
   
    let params: MeasureParams = {
      measure: this.clone,
      mode: this.mode,
      model: this.model,
      callback: this.backFromAddMeasurePop.bind(this)
    }

    this.subPop = new WizPopUp(
      AddMeasurePop,
      true,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      '680px',
      '360px',
      params
    ).show();
  }
  /**
   * retour de popUp d'ajout de mesure
   * @param fkd FeiKeyDef
   */
  private backFromAddMeasurePop(fkd: FeiKeyDef): void {
    PopUpManager.doHide(this.subPop, true);
    this.subPop = null;
    if (fkd) {
      this.addPart([fkd.fullCode]);
    }
  }

  /** suppression des combos de filtres (avant changement de step, ou sur retour de pop) */
  private clearInputs(): void {
    this.containerInputs.clear(); // vider le container des favoris
    this.inputComponents = []; // on rince la référence aux filtres
  }

  /** fermeture de la zone d'édition de formules */
  public closeSub(): void {
    this.currentEditedFunction = null;
    this.buildInputs();
    this.currentDescHtml = this.sanitizer.bypassSecurityTrustHtml('');
  }

  /**
   * construction des inputs de saisie
   */
  private buildInputs() {
    this.clearInputs();

    if (this.currentEditedFunction) {
      // mode complexe
      this.mainEdit.visible = false;
      this.lblSubTitle.wizLabel = this.currentEditedFunction.getCodeAndLabel();
      this.subClose.visible = true;
      let paramIdx: number = 0; // alimentation de chaque zone de paramètres

      // TODO si unlimitedParam, compter ceux de la formule, + 1
      if (this.currentEditedFunction.unlimitedParameters) {
        let goodLen: number = this.currentEditedFunction.mmi.c.length;
        while (goodLen >= 0) {
          goodLen--;
          const meCompo: ComponentRef<FormulaEditorInput> = WizComponentManager.instance.addChildTo(
            FormulaEditorInput,
            this.containerInputs,
            {
              instanceProperties: {
                datas: [
                  this.currentEditedFunction,
                  paramIdx,
                  this.subEditCallback.bind(this),
                  this.subFocusCallback.bind(this),
                ],
              },
            }
          );
          paramIdx++;
          this.inputComponents.push(meCompo);
        }
      } else {
        this.currentEditedFunction.parameters.forEach((param: string) => {
          const meCompo: ComponentRef<FormulaEditorInput> = WizComponentManager.instance.addChildTo(
            FormulaEditorInput,
            this.containerInputs,
            {
              instanceProperties: {
                datas: [
                  this.currentEditedFunction,
                  paramIdx,
                  this.subEditCallback.bind(this),
                  this.subFocusCallback.bind(this),
                ],
              },
            }
          );
          paramIdx++;
          this.inputComponents.push(meCompo);
        });
      }
    } else {
      // mode simple
      this.lblSubTitle.wizLabel = '$.formula.editor.title.$';
      this.subClose.visible = false;
      this.mainEdit.visible = true;
      setTimeout(() => {
        this.mainEdit.wizFocus();
        const field: string = '_wizInput';
        this.mainEdit[field].nativeElement.selectionStart = this.currentCaretStart;
        this.mainEdit[field].nativeElement.selectionEnd = this.currentCaretEnd;
        this.lastFocusComponent = this.mainEdit;
      }, 0);
    }
  }

  /**
   * sur function à paramètres infinis, demande d'ajout lors de la saisie sur le dernier élément
   * @param formulaEI le composant de saisie de params
   */
  public askForMoreInput(newFuncParam: FunctionObj): void {
    const neoMMi: MeasModeItem = MeasureCoreEngine.buildRawMMI(newFuncParam.mm, '');
    newFuncParam.mmi.c.push(neoMMi);
    const meCompo: ComponentRef<FormulaEditorInput> = WizComponentManager.instance.addChildTo(
      FormulaEditorInput,
      this.containerInputs,
      {
        instanceProperties: {
          datas: [
            this.currentEditedFunction,
            newFuncParam.mmi.c.length - 1,
            this.subEditCallback.bind(this),
            this.subFocusCallback.bind(this),
          ],
        },
      }
    );
    this.inputComponents.push(meCompo);
    // console.log('askformore', newFuncParam, meCompo);
  }

  /**
   * passage à nul de l'avant dernier paramètre, et dernier null
   * @param formulaEI le composant de saisie de params
   */
  public askForLessInput(formulaEI: FormulaEditorInput): void {
    const toPopCompo = this.inputComponents.splice(formulaEI.paramIdx, 1)[0];
    WizComponentManager.instance.removeChildFrom(toPopCompo, this.containerInputs);

    formulaEI.source.mmi.c.splice(formulaEI.paramIdx, 1);
    // console.log('form', formulaEI.source.mmi.content);

    let idx: number = 0; // on reconstruit les indices
    this.inputComponents.forEach((cref: ComponentRef<FormulaEditorInput>) => {
      cref.instance.paramIdx = idx;
      if (formulaEI.source.mmi.c[cref.instance.paramIdx]) {
        // le dernier est vide
        cref.instance.currentFormula = formulaEI.source.mmi.c[cref.instance.paramIdx].form;
      } else {
        cref.instance.currentFormula = '';
      }
      idx++;
    });

    // on redonne le focus au composant précédent
    this.lastFocusComponent = this.inputComponents[formulaEI.paramIdx].instance.mainEdit;
    setTimeout(() => {
      this.lastFocusComponent.wizFocus();
      const newCaretPos: number = this.inputComponents[formulaEI.paramIdx].instance.currentFormula.length;
    }, 0);
  }

  /**
   * sur prise de focus d'un champ de param, alimentation du currentFocusCompo
   * @param compo le textArea
   */
  private subFocusCallback(compo: WizTextarea): void {
    this.lastFocusComponent = compo;
  }

  /**
   * ajout de la saisie des params à la chaine globale
   * @param formulaEI le composant de saisie de params
   */
  private subEditCallback(formulaEI: FormulaEditorInput): void {

    this.lastFocusComponent = formulaEI.mainEdit; // alimenter le composant de focus en cours
    const newFuncParam: FunctionObj = formulaEI.source;

    // if (formulaEI.infiniteEmpty) {
    //   this.askForLessInput(formulaEI);
    // }

    if (formulaEI.source.unlimitedParameters) {
      // suppression possible du paramètre s'il est vide
      if (formulaEI.currentFormula.length === 0) {
        // il est vide
        if (this.inputComponents[this.inputComponents.length - 1].instance !== formulaEI) {
          // et ce n'est pas le dernier
          this.askForLessInput(formulaEI);
          // console.log('emptyParam', formulaEI);
        }
      }
    }

    // const fromEnd: number = this.currentFormula.length - this.currentCaretEnd; // récupérer la borne de fin
    const startPart: string = this.currentFormula.substring(0, this.currentCaretStart);
    const endPart: string = this.currentFormula.substring(this.currentCaretEnd, this.currentFormula.length);

    const parts: string[] = [];
    newFuncParam.mmi.c.forEach((mmi: MeasModeItem) => {
      if (mmi.form && mmi.form.length > 0) {
        parts.push(mmi.form);
      } else {
        parts.push('');
      }
    });
    const newStr: string = newFuncParam.code + '(' + parts.join(';') + ')';
    // console.log('newStr', startPart, '###', newStr, '###', endPart);

    // repérer la nouvelle borne de fin
    // this.currentFormulaParts.splice(newFuncParam.currentPart, newFuncParam.currentPartEnd - newFuncParam.currentPart, newStr);
    this.currentFormula = [startPart, newStr, endPart].join('');
    this.currentCaretEnd = [startPart, newStr].join('').length;
    this.clone['formula' + this.mode] = this.currentFormula;
    newFuncParam.feedDatas(this.model.measureEngine.currentFEI, this.clone, this.mode);
    this.spanMe();

    if (formulaEI.lastInfiniteParamFromVoid) {
      this.askForMoreInput(newFuncParam);
    }
  }
}
